import { render } from "./FaqSearch.vue?vue&type=template&id=2edaf728&lang=pug"
import script from "./FaqSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqSearch.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__